import React from 'react';
import PropTypes from 'prop-types';

import { Grid, Stack, Typography } from '@mui/material';

import useResponsiveScreen from 'src/hooks/useResponsiveScreen';

import { titleHeadingStyle, titleHeadingStyleSmole } from 'src/pages/style';

import ActionButton from '../action-button/action-button';

function BannerPage({ title, actionClick, textButton, titleButton }) {
  const { isSmallScreen } = useResponsiveScreen();
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      mb={isSmallScreen ? 2 : 5}
    >
      <Typography
        style={isSmallScreen ? titleHeadingStyleSmole : titleHeadingStyle}
        mx={1}
      >
        {title}
      </Typography>
      <Grid>
        <ActionButton
          id="add-client-cred-btn"
          onClick={actionClick}
          icon={isSmallScreen ? 'octicon:plus-circle-16' : 'eva:plus-fill'}
          text={textButton}
          title={titleButton}
        />
      </Grid>
    </Stack>
  );
}

BannerPage.propTypes = {
  title: PropTypes.string,
  actionClick: PropTypes.func,
  textButton: PropTypes.string,
  titleButton: PropTypes.string,
};

export default BannerPage;
